export default __webpack_public_path__ + "static/media/apparel.ce280c67.jpg";